module.exports = __webpack_public_path__ + "static/media/WatermarkImg.961a1df2.png";